import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import {Signals} from "@/Imports";
import ScaleManager from "../stage/ScaleManager";
import Utils from "@base/utils/Utils";
import gsap from "gsap";

export default class StarsContainer extends BaseContainer {

  constructor(data) {
    super(data)
    this.init()
  }

  init(data) {
    // this.blank = new PIXI.Graphics()
    // this.blank.beginFill(0xff0000, 0.2)
    // this.blank.drawRect(50,50, 800, 500)
    // this.blank.endFill()
    // this.addChild(this.blank)

    this.starsContainer = new PIXI.Container()
    this.addChild(this.starsContainer)
    this.baseStars = ['star_1', 'star_2', 'star_3']
    this.MAX_STARS = 50
    this.stars = new Array(this.MAX_STARS)
      .fill(1)
      .map(v => this.baseStars[Utils.getRandomInt(0, this.baseStars.length - 1)])
      .map(v => {
        const x = Utils.getRandomInt(0, ScaleManager.currentSizes.total.width/2)
        const y = Utils.getRandomInt(0, ScaleManager.currentSizes.total.height/2)
        const star = new PIXI.Sprite(PIXI.Texture.from(v))
        star.scale.set(Utils.randomNumber(0.3, 1))
        star.position.set(x, y)
        star.rotation = Utils.randomNumber(-Math.PI, Math.PI)
        star.blink = () => {
          gsap.to(star, Utils.randomNumber(.1, .2), {alpha: Utils.randomNumber(0.6, 1), onComplete: star.blink})
        }
        star.blink()
        this.starsContainer.addChild(star)
        return star
      })
  }
}
